import React from "react";
import { Field, Input, Textarea, SectionTitle, Card } from "./_shared";
import { X, Plus } from "lucide-react";

export default function ExperienciasEditor({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setExp = (i, patch) => {
    const experiencias = value.experiencias.map((x, idx) => idx === i ? { ...x, ...patch } : x);
    onChange({ ...value, experiencias });
  };
  const addExp = () => onChange({ ...value, experiencias: [...value.experiencias, { title: "Nueva", description: "", duration: "60 min", image: "" }] });
  const removeExp = (i) => onChange({ ...value, experiencias: value.experiencias.filter((_, idx) => idx !== i) });

  return (
    <div>
      <SectionTitle title="Página Experiencias" subtitle="Catálogo de experiencias Kilombo" />
      <Card className="mb-4">
        <h3 className="font-display text-xl mb-4">Hero</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Eyebrow"><Input value={value.hero_eyebrow} onChange={(e) => set("hero_eyebrow", e.target.value)} /></Field>
          <div />
          <div className="md:col-span-2">
            <Field label="Título (las primeras 2 palabras se colorean en naranja, el resto en teal)">
              <Textarea rows={2} value={value.hero_title} onChange={(e) => set("hero_title", e.target.value)} />
            </Field>
          </div>
          <div className="md:col-span-2">
            <Field label="Descripción"><Textarea rows={3} value={value.hero_description} onChange={(e) => set("hero_description", e.target.value)} /></Field>
          </div>
        </div>
      </Card>

      <Card>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-xl">Experiencias</h3>
          <button onClick={addExp} className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors">
            <Plus className="w-3 h-3" /> Añadir
          </button>
        </div>
        <div className="space-y-3">
          {value.experiencias.map((x, i) => (
            <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_140px_40px] gap-2 p-3 rounded-lg bg-black/40 border border-white/5">
              <div className="space-y-2">
                <Input value={x.title} onChange={(e) => setExp(i, { title: e.target.value })} placeholder="Título" />
                <Input value={x.image} onChange={(e) => setExp(i, { image: e.target.value })} placeholder="URL imagen" />
                <Textarea rows={2} value={x.description} onChange={(e) => setExp(i, { description: e.target.value })} placeholder="Descripción" />
              </div>
              <Input value={x.duration} onChange={(e) => setExp(i, { duration: e.target.value })} placeholder="Duración" />
              <button onClick={() => removeExp(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors self-start">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
